import { useContext } from 'react';

import { useMutation, useQueryClient } from 'react-query';

import { AlertSnackbarContext } from '../../../components/snackbars';
import Api from '../../api/api';

export type RejectPostRequestOverrideDTO = {
  rejectedReason?: string;
};

export const rejectPostRequestOverride = async (requestId: string, dto: RejectPostRequestOverrideDTO) => {
  const [response, bodyOrError] = await Api.patch(`posts/requests/${requestId}/reject`, dto);

  if (!response.ok) {
    throw bodyOrError;
  }

  return response;
};

export const useRejectPostRequestOverride = () => {
  const queryClient = useQueryClient();

  const [, setAlertSnackbar] = useContext(AlertSnackbarContext);

  return useMutation(
    'rejectPostRequestOverride',
    (data: { requestId: string; dto: RejectPostRequestOverrideDTO }) => {
      return rejectPostRequestOverride(data.requestId, data.dto);
    },
    {
      onSuccess: (data, vars, ctx) => {
        queryClient.invalidateQueries('getAllPostRequests');
        queryClient.invalidateQueries('getPostRequestOverride');
        setAlertSnackbar({
          message: 'Post request override rejected successfully',
          severity: 'success',
        });
      },
      onError: (error: any) => {
        setAlertSnackbar({
          message: error?.message || 'An error occurred while rejecting the post request override',
          severity: 'error',
        });
      },
    },
  );
};
